import { AxiosError } from "axios";
import { linkAPI } from "../../services/linkAPI";
import { useMutation, useQuery } from "react-query";
import { LinkPlanPatch } from "../../types/link.types";
import { CallbackFunction } from "../../../minigrid/hook/core/useMinigridCore";

export interface PlanLinkCoreProps {
  planId: string;
  setHeaderAuthToFutureResquest?: () => void;
}

export default function usePlanLinkCore({
  setHeaderAuthToFutureResquest,
  planId,
}: PlanLinkCoreProps) {
  setHeaderAuthToFutureResquest && setHeaderAuthToFutureResquest();

  const allLinkQuery = useQuery({
    queryKey: ["planLink", planId],
    queryFn: () => linkAPI.getAllLinkFromPlan(0, 0, planId),
  });

  const createNewLink = useMutation({
    mutationFn: ({
      newLink,
      callback,
    }: {
      newLink: LinkPlanPatch;
      callback?: CallbackFunction;
    }) =>
      linkAPI
        .createLinkPlan(newLink, planId)
        .then((res) => {
          callback && callback({ result: res });
          return Promise.resolve(res);
        })
        .catch((error) => {
          callback && callback({ error });
          return Promise.reject(error);
        }),

    onSettled: () => {
      allLinkQuery.refetch();
    },

    onSuccess: () => {
      allLinkQuery.refetch();
    },
  });

  const updateLink = useMutation({
    mutationFn: ({
      linkId,
      newLink,
      callback,
    }: {
      linkId: string;
      newLink: LinkPlanPatch;
      callback?: CallbackFunction;
    }) =>
      linkAPI
        .updateLinkPlan(linkId, newLink, planId)
        .then((res) => {
          callback && callback({ result: res });
          return Promise.resolve(res);
        })
        .catch((error) => {
          callback && callback({ error });
          return Promise.reject(error);
        }),

    onSettled: () => {
      allLinkQuery.refetch();
    },

    onSuccess: () => {
      allLinkQuery.refetch();
    },
  })

  const deleteLink = useMutation({
    mutationFn: ({
      linkId,
      callback,
    }: {
      linkId: string;
      callback?: CallbackFunction;
    }) =>
      linkAPI
        .deleteLinkPlan(linkId, planId)
        .then((res) => {
          callback && callback({ result: res });
          return Promise.resolve(res);
        })
        .catch((error) => {
          callback && callback({ error });
          return Promise.reject(error);
        }),

    onSettled: () => {
      allLinkQuery.refetch();
    },

    onSuccess: () => {
      allLinkQuery.refetch();
    },
  })

  return {
    allLinkQuery: {
      ...allLinkQuery,
      error: allLinkQuery.error as AxiosError,
    },

    createNewLink: {
      ...createNewLink,
      error: createNewLink.error as AxiosError,
    },

    updateLink: {
      ...updateLink,
      error: updateLink.error as AxiosError,
    },

    deleteLink: {
      ...deleteLink,
      error: deleteLink.error as AxiosError,
    },
  };

}
